import React from 'react'

const NotificationSettings = () => {
  return (
    <div className="account-setting-page-container">
      Coming soon
    </div>
  )
}

export default NotificationSettings